import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const PaymentCancel = () => {
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    // Get payment details from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get("session_id");
    const provider = urlParams.get("provider");

    if (sessionId || provider) {
      setPaymentDetails({
        sessionId,
        provider: provider || "unknown",
      });
    }

    // Clean up any stored payment data
    localStorage.removeItem("payment_session_id");
    localStorage.removeItem("thawani_session_id");
  }, []);

  const handleRetryPayment = () => {
    // Redirect back to upgrade page to retry payment
    window.location.href = "/upgrade-plan";
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg-50 px-4">
      <div className="max-w-md w-full text-center">
        {/* Cancel Icon */}
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <X className="w-8 h-8 text-red-600" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-fg-50 mb-4">
          Payment Cancelled
        </h1>

        {/* Message */}
        <p className="text-fg-60 text-lg mb-8">
          Your payment was cancelled. No charges have been made to your account.
        </p>

        {/* Payment Details (if available) */}
        {paymentDetails && (
          <div className="bg-bg-60 rounded-lg p-4 mb-8 text-left">
            <h3 className="font-medium text-fg-50 mb-2">Payment Details</h3>
            <div className="space-y-1 text-sm text-fg-60">
              {paymentDetails.sessionId && (
                <div>
                  <span className="font-medium">Session ID:</span>{" "}
                  <span className="break-all">
                    {paymentDetails.sessionId.length > 30
                      ? `${paymentDetails.sessionId.substring(0, 30)}...`
                      : paymentDetails.sessionId}
                  </span>
                </div>
              )}
              <div>
                <span className="font-medium">Provider:</span>{" "}
                {paymentDetails.provider}
              </div>
              <div>
                <span className="font-medium">Status:</span> Cancelled
              </div>
            </div>
          </div>
        )}

        {/* Action Buttons */}
        <div className="grid grid-cols-2 gap-3">
          {/* Retry Payment Button */}
          <button
            onClick={handleRetryPayment}
            className="bg-ac-02 text-white dark:text-black py-3 px-4 rounded-full font-medium hover:bg-ac-01 transition-all duration-200"
          >
            Try Again
          </button>

          {/* Go Home Button */}
          <button
            onClick={handleGoHome}
            className="bg-transparent border border-bd-50 text-fg-50 py-3 px-4 rounded-full font-medium hover:bg-bg-60 transition-all duration-200"
          >
            Back to Home
          </button>
        </div>

        {/* Help Text */}
        <div className="mt-8 text-sm text-fg-60">
          <p>
            Need help? Contact our{" "}
            <a
              href="/contact"
              className="text-ac-02 hover:text-ac-01 underline"
            >
              support team
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
